// @ts-nocheck
/**
 * postProcess.ts
 * addLayers()実行後のハイライト処理
 * 地番図系レイヤーのハイライトを一括適用
 */

import {
  highlightSpecificFeatures,
  highlightSpecificFeaturesCity,
  highlightSpecificFeatures2025,
} from '@/js/downLoad'

// 地番図系ハイライト対象レイヤー（amx-a-fudeは個別関数）
const CHIBANZU_HIGHLIGHT_LAYERS = [
  'oh-chibanzu2024',
  'oh-kitahiroshimachiban',
  'oh-narashichiban',
  'oh-iwatapolygon',
  'oh-fukushimachiban',
  'oh-kunitachishi',
  'oh-fukuokashichiban',
  'oh-chibanzu-室蘭市',
  'oh-chibanzu-ニセコ町',
  'oh-chibanzu-音更町',
  'oh-chibanzu-鹿角市',
  'oh-chibanzu-舟形町',
  'oh-chibanzu-利根町',
  'oh-chibanzu-小平市',
  'oh-chibanzu-町田市',
  'oh-chibanzu-静岡市',
  'oh-chibanzu-磐田市',
  'oh-chibanzu-半田市',
  'oh-chibanzu-京都市',
  'oh-chibanzu-長岡京市',
  'oh-chibanzu-岸和田市',
  'oh-chibanzu-泉南市',
  'oh-chibanzu-西宮市',
  'oh-chibanzu-加古川市',
  'oh-chibanzu-佐用町',
  'oh-chibanzu-奈良市',
  'oh-chibanzu-坂出市',
  'oh-chibanzu-善通寺市',
  'oh-chibanzu-長与町',
  'oh-chibanzu-福島市',
  'oh-chibanzu-北広島市',
  'oh-chibanzu-国立市',
  'oh-chibanzu-福岡市',
  'oh-chibanzu-越谷市',
  'oh-chibanzu-福山市',
  'oh-chibanzu-深谷市',
  'oh-chibanzu-伊丹市',
  'oh-chibanzu-豊中市',
  'oh-chibanzu-姫路市',
]

/**
 * 地番図系レイヤーのハイライト処理を一括適用
 * addLayers()のフルリビルド後に呼び出す
 */
export function applyHighlights(map: unknown): void {
  // 2025登記所地図（筆ポリゴン）のハイライト復元
  if (map.getLayer('oh-homusyo-2025-polygon')) highlightSpecificFeatures2025(map, 'oh-homusyo-2025-polygon')
  if (map.getLayer('oh-amx-a-fude')) highlightSpecificFeatures(map, 'oh-amx-a-fude')
  for (const layerId of CHIBANZU_HIGHLIGHT_LAYERS) {
    if (map.getLayer(layerId)) highlightSpecificFeaturesCity(map, layerId)
  }
}
